var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("home")]),_c('div',[_c('h2',[_vm._v("登录/授权")]),_c('button',{on:{"click":_vm.auth}},[_vm._v("登录")]),(_vm.isWechat)?_c('button',{on:{"click":_vm.unbind}},[_vm._v("取消绑定")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }